/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

/* ==========================================================================
 * LOUPE CUSTOMISATIONS - READ BEFORE UPDATING BROADCAST
 *
 * This file adds these things to product pages:
 *   1. Variant image filter - the gallery shows only the selected scent's images
 *   2. Gallery dots         - phones: line navigation under the product gallery
 *                             (all product pages; desktop has the theme's arrows)
 *   3. Scent tiles (phones) - image tiles replacing the "Kokunu Seç" dropdown,
 *                             with the selected scent's full name beside
 *                             "Kokunu Seç". Desktop keeps the dropdown.
 *   4. Gallery height       - desktop: image frame sized so its lines line up
 *                             with the "Özel Setleri Keşfet" slider's lines
 *                             (all product pages)
 *   5. FAQ in pages         - "Sık Sorulanlar": more than 6 questions are
 *                             split into pages of 6 with lines to switch
 *
 * It needs, in the same theme:
 *   - assets/custom.js          (this file)
 *   - assets/loupe-product.css  (styles for all of the above)
 *   - layout/theme.liquid       (loads both files; adds data-scent-tiles on <html>)
 *
 * A Broadcast update creates a fresh theme WITHOUT these changes.
 * Copy all three back into the updated theme, then re-test a product page.
 * (The previous alt-text filter was lost exactly this way in Oct 2025.)
 *
 * HOW TO ASSIGN IMAGES TO A SCENT (in Shopify admin > product > media):
 *   - the image picked on the variant itself always belongs to that scent;
 *   - any other image belongs to a scent when its ALT TEXT is the scent name,
 *     optionally followed by a space and more words, e.g.
 *       "12 | Lavanta. Itır Çiçeği. Sandal Ağacı."
 *       "12 | Lavanta. Itır Çiçeği. Sandal Ağacı. Kutu"
 *     (upper/lower case and extra spaces don't matter);
 *   - images whose alt text matches no scent are shown for EVERY scent.
 * ========================================================================== */

(function() {
  // Add custom code below this line

  // Options shown as image tiles instead of a dropdown. Must match the option
  // name in Shopify (and the list in layout/theme.liquid).
  var TILE_OPTIONS = ['Kokunu Seç'];

  var SLIDE = '[data-image-id]';
  var THUMB = '[data-thumb-item]';
  var THUMB_LINK = '[data-thumb-link]';
  var ACTIVE = 'media--active';
  var HIDDEN = 'media--hidden';
  var HIDING = 'media--hiding';
  var LOADING = 'is-loading';

  /* ---------------------------------------------------------------- helpers */

  function norm(value) {
    return String(value || '')
      .replace(/\s+/g, ' ') // \s also covers non-breaking spaces
      .trim()
      .toLowerCase();
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function warn(err) {
    if (window.console) console.warn('LOUPE product customisations:', err);
  }

  function isMobile() {
    return !!(window.theme && window.theme.isMobile && window.theme.isMobile());
  }

  // Position (0-based) of the first option listed in TILE_OPTIONS, or -1.
  function scentOptionIndex(product) {
    var wanted = TILE_OPTIONS.map(norm);
    var names = (product.options || []).map(function (o) {
      return typeof o === 'string' ? o : (o && o.name);
    });
    for (var i = 0; i < names.length; i++) {
      if (wanted.indexOf(norm(names[i])) !== -1) return i;
    }
    return -1;
  }

  // Everything in this file only runs on products with a TILE_OPTIONS option
  // (Deo 60ml, mDeo 30ml). All other products - e.g. the sets - are untouched.
  function isScentProduct(product) {
    return !!product && scentOptionIndex(product) !== -1;
  }

  function getProduct(container) {
    if (container.__vmfProduct !== undefined) return container.__vmfProduct;
    container.__vmfProduct = null;
    var json = container.querySelector('[data-product-json]');
    if (json) {
      try { container.__vmfProduct = JSON.parse(json.textContent); } catch (e) { warn(e); }
    }
    return container.__vmfProduct;
  }

  function currentVariant(container, product) {
    var variants = product.variants || [];
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });

    // The section also holds upsell forms with their own [name="id"] inputs,
    // so use the first one whose value is a variant of THIS product.
    var inputs = container.querySelectorAll('[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      if (byId[inputs[i].value]) return byId[inputs[i].value];
    }
    var match = window.location.search.match(/[?&]variant=(\d+)/);
    if (match && byId[match[1]]) return byId[match[1]];
    return variants.filter(function (v) { return v.available; })[0] || variants[0];
  }

  // Scroll a horizontally scrolling gallery so `slide` is at its left edge.
  function scrollToSlide(list, slide, smooth) {
    var left = list.scrollLeft + slide.getBoundingClientRect().left - list.getBoundingClientRect().left;
    if (list.scrollTo) list.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
    else list.scrollLeft = left;
  }

  /* ------------------------------------------------- 1. variant image filter */

  function altMatches(alt, value) {
    return alt === value || alt.indexOf(value + ' ') === 0;
  }

  // mediaId -> { variantId: true } for scent-specific media, null for shared.
  // Returns null when nothing on the product is tied to a variant.
  function buildOwners(product) {
    var media = product.media || [];
    var variants = product.variants || [];
    var owners = {};
    var anyOwned = false;

    media.forEach(function (m) { owners[m.id] = null; });

    variants.forEach(function (variant) {
      var values = (variant.options || []).map(norm).filter(Boolean);
      var featuredId = variant.featured_media && variant.featured_media.id;

      media.forEach(function (m) {
        var alt = norm(m.alt).replace(/^variant--\s*/, '');
        var mine = m.id === featuredId ||
          (alt !== '' && values.some(function (v) { return altMatches(alt, v); }));
        if (mine) {
          owners[m.id] = owners[m.id] || {};
          owners[m.id][variant.id] = true;
          anyOwned = true;
        }
      });
    });

    return anyOwned ? owners : null;
  }

  // Set of media ids to show for a variant, or null to show everything.
  function allowedFor(owners, variant) {
    var allowed = {};
    var count = 0;
    Object.keys(owners).forEach(function (id) {
      var o = owners[id];
      if (!o || o[variant.id]) { allowed[id] = true; count++; }
    });
    return count ? allowed : null;
  }

  function thumbMediaId(thumb) {
    var link = thumb.querySelector(THUMB_LINK);
    var id = link && link.getAttribute('data-media-id');
    return id ? id.split('-').pop() : null;
  }

  function makeEnd(after) {
    var end = document.createElement('span');
    end.setAttribute('data-vmf-end', '');
    end.setAttribute('aria-hidden', 'true');
    end.style.display = 'none';
    after.parentNode.insertBefore(end, after.nextSibling);
    return end;
  }

  // Keep `items` whose id is allowed, in original order, right before `end`.
  // Detach the rest so the theme's next/previous/swipe can't reach them.
  function syncItems(items, idOf, allowed, end, onDetach) {
    var kept = [];
    items.forEach(function (item) {
      var keep = !allowed || allowed[idOf(item)];
      if (keep) {
        kept.push(item);
      } else if (item.parentNode) {
        if (onDetach) onDetach(item);
        item.parentNode.removeChild(item);
      }
    });
    var ref = end;
    for (var i = kept.length - 1; i >= 0; i--) {
      if (kept[i].parentNode !== end.parentNode || kept[i].nextElementSibling !== ref) {
        end.parentNode.insertBefore(kept[i], ref);
      }
      ref = kept[i];
    }
    return kept;
  }

  // Broadcast keeps an image invisible ("is-loading") until its load event
  // reaches the page. Images of other scents are taken out of the page, and
  // one that finishes loading while out of the page would stay invisible
  // (blank first image after picking a scent, fixed only by a refresh).
  // So also listen on the images themselves and clear it the same way.
  function markLoaded(img) {
    if (!img.classList.contains(LOADING)) return;
    img.classList.remove(LOADING);
    var parent = img.parentNode;
    if (parent && parent.classList) {
      parent.classList.remove(LOADING);
      var grand = parent.parentNode;
      if (grand && grand.classList) grand.classList.remove(LOADING);
    }
  }

  function settleImages(items) {
    items.forEach(function (item) {
      toArray(item.querySelectorAll('img')).forEach(function (img) {
        if (img.complete && img.naturalWidth) markLoaded(img);
      });
    });
  }

  function watchImages(items) {
    items.forEach(function (item) {
      toArray(item.querySelectorAll('img')).forEach(function (img) {
        if (img.__vmfLoad) return;
        img.__vmfLoad = true;
        img.addEventListener('load', function () { markLoaded(img); });
      });
    });
    settleImages(items);
  }

  function setupFilter(container) {
    if (container.__vmf !== undefined) return container.__vmf;
    container.__vmf = null;

    var product = getProduct(container);
    var images = container.querySelector('product-images');
    var list = images && images.querySelector('[data-product-media-list]');
    if (!product || !images || !list) return null;

    var owners = buildOwners(product);
    var slides = toArray(list.querySelectorAll(SLIDE));
    if (!owners || slides.length < 2) return null;

    var thumbsEl = images.querySelector('product-thumbs');
    var holder = thumbsEl && thumbsEl.querySelector('[data-thumbs-slider]');
    var thumbs = holder ? toArray(holder.querySelectorAll(THUMB)) : [];

    watchImages(slides.concat(thumbs));

    container.__vmf = {
      owners: owners,
      images: images,
      list: list,
      slides: slides,
      slideEnd: makeEnd(slides[slides.length - 1]),
      thumbs: thumbs,
      thumbEnd: thumbs.length ? makeEnd(thumbs[thumbs.length - 1]) : null,
      current: null
    };
    return container.__vmf;
  }

  function applyFilter(state, variant) {
    if (!variant || !variant.id || state.current === variant.id) return;
    state.current = variant.id;

    var allowed = allowedFor(state.owners, variant);

    var kept = syncItems(
      state.slides,
      function (slide) { return slide.getAttribute('data-image-id'); },
      allowed,
      state.slideEnd,
      function (slide) {
        slide.classList.remove(ACTIVE, HIDING);
        slide.classList.add(HIDDEN);
      }
    );

    var keptThumbs = [];
    if (state.thumbEnd) {
      keptThumbs = syncItems(state.thumbs, thumbMediaId, allowed, state.thumbEnd, function (thumb) {
        thumb.classList.remove('is-active');
      });
    }
    settleImages(kept.concat(keptThumbs));

    // The theme caches its slide list; point it at the visible slides.
    state.images.productMediaItems = kept;
    state.images.toggleAttribute('data-vmf-single', kept.length < 2);

    var featuredId = variant.featured_media && String(variant.featured_media.id);
    var target = kept.filter(function (s) {
      return s.getAttribute('data-image-id') === featuredId;
    })[0] || kept[0];

    if (target) {
      // Let the theme do the switch (fade, height, active thumbnail).
      state.images.dispatchEvent(new CustomEvent('theme:media:select', {
        detail: { id: target.getAttribute('data-media-id') }
      }));
      // Mobile "Slider" layout scrolls horizontally instead of fading.
      if (isMobile() && !state.images.hasAttribute('data-fader-mobile')) {
        scrollToSlide(state.list, target, false);
      }
    }

    refreshDots(state.images);
  }

  /* ---------------------------------------------------------- 2. gallery dots */

  function dotsScrollMode(d) {
    return isMobile() && !d.images.hasAttribute('data-fader-mobile');
  }

  function dotsFor(images) {
    if (images.__vmfDots !== undefined) return images.__vmfDots;
    images.__vmfDots = null;

    var list = images.querySelector('[data-product-media-list]');
    if (!list) return null;

    var wrap = document.createElement('div');
    wrap.className = 'vmf-dots';
    wrap.hidden = true;
    list.parentNode.insertBefore(wrap, list.nextSibling);

    var d = { images: images, list: list, wrap: wrap, slides: [], buttons: [] };

    wrap.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-vmf-dot]');
      if (!btn) return;
      var slide = d.slides[Number(btn.getAttribute('data-vmf-dot'))];
      if (!slide) return;
      if (dotsScrollMode(d)) {
        scrollToSlide(d.list, slide, true);
      } else {
        d.images.dispatchEvent(new CustomEvent('theme:media:select', {
          detail: { id: slide.getAttribute('data-media-id') }
        }));
      }
    });

    new MutationObserver(function () { updateDots(d); })
      .observe(images, { attributes: true, attributeFilter: ['data-active-media'] });

    var ticking = false;
    list.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; updateDots(d); });
    }, { passive: true });

    images.__vmfDots = d;
    return d;
  }

  function refreshDots(images) {
    var d = dotsFor(images);
    if (!d) return;

    d.slides = toArray(d.list.children).filter(function (el) {
      return el.hasAttribute('data-image-id');
    });
    d.wrap.innerHTML = '';
    d.buttons = d.slides.map(function (slide, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vmf-dot';
      btn.setAttribute('data-vmf-dot', String(i));
      btn.setAttribute('aria-label', (i + 1) + ' / ' + d.slides.length);
      d.wrap.appendChild(btn);
      return btn;
    });
    d.wrap.hidden = d.slides.length < 2;
    updateDots(d);
  }

  function updateDots(d) {
    if (!d.buttons.length) return;
    var index = 0;

    if (dotsScrollMode(d)) {
      var left = d.list.getBoundingClientRect().left;
      var best = Infinity;
      d.slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.getBoundingClientRect().left - left);
        if (dist < best) { best = dist; index = i; }
      });
    } else {
      var activeId = d.images.getAttribute('data-active-media');
      d.slides.forEach(function (slide, i) {
        if (slide.getAttribute('data-media-id') === activeId) index = i;
      });
    }

    d.buttons.forEach(function (btn, i) {
      btn.classList.toggle('is-active', i === index);
      if (i === index) btn.setAttribute('aria-current', 'true');
      else btn.removeAttribute('aria-current');
    });
  }

  /* ----------------------------------------------------------- 3. scent tiles */

  // "12 |  Lavanta. Itır..." -> "12 | Lavanta. Itır..." (single spaces)
  function displayName(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function sizedUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function setupTiles(container) {
    if (container.__vmfTiles !== undefined) return container.__vmfTiles;
    container.__vmfTiles = null;

    var product = getProduct(container);
    if (!product) return null;

    var pos = scentOptionIndex(product);
    if (pos === -1) return null;

    // Tiles only when every variant has its own image (same rule as
    // layout/theme.liquid); otherwise the dropdown stays.
    var variantsAll = product.variants || [];
    var allHaveImages = variantsAll.length > 0 && variantsAll.every(function (v) {
      return v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src;
    });
    if (!allHaveImages) return null;

    var wrapper = container.querySelector('.selector-wrapper[data-option-position="' + (pos + 1) + '"]');
    var fieldset = wrapper && wrapper.querySelector('.select__fieldset');
    var popout = fieldset && fieldset.querySelector('popout-select');
    if (!popout) return null;

    var links = toArray(popout.querySelectorAll('a.select-popout__option[data-value]'));
    if (!links.length) return null;

    var label = fieldset.querySelector('.radio__legend__label[id]');

    // Phones show the selected scent's full name next to "Kokunu Seç"
    // ("12 | Lavanta. Itır Çiçeği. Sandal Ağacı."). Desktop keeps the theme's
    // own short summary ("12 | Bitkisel, Odunsu", from custom-legend.js),
    // because the dropdown there already shows the full name. CSS decides
    // which of the two is visible.
    var fullName = document.createElement('span');
    fullName.className = 'vmf-legend-full';
    var summary = fieldset.querySelector('[data-legend-target]');
    if (summary) summary.parentNode.insertBefore(fullName, summary.nextSibling);
    else if (label) label.appendChild(fullName);

    var row = document.createElement('div');
    row.className = 'vmf-tiles';
    row.setAttribute('role', 'group');
    if (label) row.setAttribute('aria-labelledby', label.id);

    var variants = product.variants || [];
    var tiles = links.map(function (link) {
      var value = link.getAttribute('data-value');
      var sample = variants.filter(function (v) { return v.options[pos] === value; })[0];
      var image = sample && sample.featured_media && sample.featured_media.preview_image;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vmf-tile';
      btn.title = displayName(value);
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', displayName(value));

      var media = document.createElement('span');
      media.className = 'vmf-tile__media';
      if (image && image.src) {
        var img = document.createElement('img');
        img.src = sizedUrl(image.src, 240);
        img.srcset = sizedUrl(image.src, 240) + ' 240w, ' + sizedUrl(image.src, 480) + ' 480w';
        img.sizes = '120px';
        img.alt = '';
        img.width = 240;
        img.height = 240;
        img.decoding = 'async';
        media.appendChild(img);
      }
      btn.appendChild(media);

      btn.addEventListener('click', function () {
        // Select through the theme's own dropdown so price, stock, add to cart
        // and the custom legend line all update exactly as before.
        if (btn.getAttribute('aria-pressed') !== 'true') link.click();
      });

      row.appendChild(btn);
      return { value: value, button: btn };
    });

    popout.parentNode.insertBefore(row, popout.nextSibling);
    fieldset.setAttribute('data-vmf-tiles', '');

    container.__vmfTiles = { pos: pos, tiles: tiles, product: product, fullName: fullName };
    return container.__vmfTiles;
  }

  function syncTiles(state, variant) {
    if (!variant) return;
    var variants = state.product.variants || [];
    state.tiles.forEach(function (tile) {
      var selected = variant.options[state.pos] === tile.value;
      tile.button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      if (selected) state.fullName.textContent = displayName(tile.value);

      // Sold out = no available variant with this scent and the other options
      // as currently selected.
      var available = variants.some(function (v) {
        if (!v.available || v.options[state.pos] !== tile.value) return false;
        return v.options.every(function (opt, i) {
          return i === state.pos || opt === variant.options[i];
        });
      });
      tile.button.classList.toggle('is-soldout', !available);
    });
  }

  /* ------------------------------------------------ 4. gallery height (desktop) */

  // Desktop: size the product image frame so its bottom lines up with the
  // "Özel Setleri Keşfet" slider's lines in the right-hand column (or the
  // column's bottom, when there is no slider). Scent products stop
  // SCENT_LINES_GAP higher, where their gallery lines were before the lines
  // were removed on desktop, so their image size didn't change.
  // The image is scaled to fit the frame, never cropped or enlarged;
  // when the frame is taller than normal the image sits centred in it.
  // Re-measured whenever either column changes size.
  var MIN_GALLERY_RATIO = 0.5; // frame never below 50% of the normal height
  var MAX_GALLERY_RATIO = 1.3; // ...or above 130% of it
  var SCENT_LINES_GAP = 17;    // 16px above the old lines + half a line

  function clearFit(images) {
    if (!images.hasAttribute('data-vmf-fit')) return;
    images.removeAttribute('data-vmf-fit');
    images.style.removeProperty('--vmf-gallery-h');
    if (typeof images.setHeight === 'function') images.setHeight();
  }

  function fitGallery(images) {
    var page = images.closest('.product__page');
    var column = page && page.querySelector('.product__content .form__width');
    var list = images.querySelector('[data-product-media-list]');
    var photo = list && list.querySelector('[data-image-id] .product__photo');

    // Only the desktop one-image-at-a-time gallery ("Thumbnails" layouts).
    if (isMobile() || !images.hasAttribute('data-fader-desktop') || !column || !photo) {
      clearFit(images);
      return;
    }

    var lines = column.querySelector('.flickity-page-dots');
    var linesBox = lines && lines.offsetParent ? lines.getBoundingClientRect() : null;
    var target = linesBox ? linesBox.top + linesBox.height / 2 : column.getBoundingClientRect().bottom;

    var container = images.closest('[data-section-type]');
    var offset = container && isScentProduct(getProduct(container)) ? SCENT_LINES_GAP : 0;

    var ratio = parseFloat(photo.style.getPropertyValue('--aspect-ratio')) || 1;
    var natural = photo.offsetWidth / ratio;
    var height = Math.round(target - list.getBoundingClientRect().top - offset);

    height = Math.min(Math.max(height, Math.round(natural * MIN_GALLERY_RATIO)),
      Math.round(natural * MAX_GALLERY_RATIO));
    if (!natural || Math.abs(height - natural) < 1) {
      clearFit(images);
      return;
    }

    if (images.getAttribute('data-vmf-fit') !== String(height)) {
      images.style.setProperty('--vmf-gallery-h', height + 'px');
      images.setAttribute('data-vmf-fit', String(height));
      // Let the theme re-measure the gallery (it caches the slide height).
      if (typeof images.setHeight === 'function') images.setHeight();
    }
  }

  function watchGallery(images) {
    if (images.__vmfFit) return;
    images.__vmfFit = true;

    var page = images.closest('.product__page');
    var column = page && page.querySelector('.product__content .form__width');
    var queued = false;
    var refit = function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        try { fitGallery(images); } catch (err) { warn(err); }
      });
    };

    if (window.ResizeObserver) {
      // Text wrapping, fonts, the reviews badge and the slider all change the
      // right column's height after load; the window size changes both.
      var observer = new ResizeObserver(refit);
      observer.observe(images);
      if (column) observer.observe(column);
    } else {
      window.addEventListener('resize', refit);
      window.addEventListener('load', refit);
    }
    refit();
  }

  /* ---------------------------------------------------------- 5. FAQ in pages */

  // "Sık Sorulanlar" (Broadcast's image + text section, "double"): with more
  // than FAQ_PAGE_SIZE questions, the questions are split into pages of
  // FAQ_PAGE_SIZE. Swipe between pages, or pick one with the lines underneath
  // (same lines as the "Özel Setleri Keşfet" slider). Product pages only.
  var FAQ_PAGE_SIZE = 6;

  function setupFaq(group) {
    if (group.__vmfFaq) return;
    var items = toArray(group.children).filter(function (el) {
      return el.hasAttribute('data-collapsible');
    });
    if (items.length <= FAQ_PAGE_SIZE) return;
    group.__vmfFaq = true;

    var wrap = document.createElement('div');
    wrap.className = 'vmf-faq';
    var track = document.createElement('div');
    track.className = 'vmf-faq__track';
    wrap.appendChild(track);
    items[0].parentNode.insertBefore(wrap, items[0]);

    // Moving the questions keeps the theme's accordion working: it holds its
    // own references to them and their click handlers stay attached.
    var pages = [];
    for (var i = 0; i < items.length; i += FAQ_PAGE_SIZE) {
      var page = document.createElement('div');
      page.className = 'vmf-faq__page';
      items.slice(i, i + FAQ_PAGE_SIZE).forEach(function (item) { page.appendChild(item); });
      track.appendChild(page);
      pages.push(page);
    }

    var lines = document.createElement('div');
    lines.className = 'vmf-dots vmf-faq__lines';
    var buttons = pages.map(function (page, index) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vmf-dot';
      btn.setAttribute('aria-label', (index + 1) + ' / ' + pages.length);
      btn.addEventListener('click', function () { go(index); });
      lines.appendChild(btn);
      return btn;
    });
    wrap.appendChild(lines);

    var current = -1;
    var lastScroll = 0;

    // Scroll position of a page (pages have a gap between them, see CSS).
    function pageLeft(index) {
      return pages[index].offsetLeft - pages[0].offsetLeft;
    }

    function nearestPage() {
      var best = 0;
      pages.forEach(function (page, i) {
        if (Math.abs(track.scrollLeft - pageLeft(i)) < Math.abs(track.scrollLeft - pageLeft(best))) best = i;
      });
      return best;
    }

    // The list keeps the height of its tallest page, so the heading and the
    // lines don't move when switching pages. A question left open on the
    // page being left is closed, so it doesn't stretch the list.
    function setActive(index) {
      index = Math.max(0, Math.min(pages.length - 1, index));
      if (index === current) return;
      if (current !== -1 && typeof group.close === 'function') {
        toArray(pages[current].querySelectorAll('[data-collapsible][open="true"]')).forEach(function (item) {
          group.close(item);
        });
      }
      current = index;
      pages.forEach(function (page, i) {
        // Questions on other pages can't be tabbed to or read out.
        page.toggleAttribute('inert', i !== index);
      });
      buttons.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
        if (i === index) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });
    }

    // While a line click scrolls to its page, ignore the pages passed on the way.
    var target = null;
    var targetTimer = 0;

    function go(index) {
      setActive(index);
      target = index;
      clearTimeout(targetTimer);
      targetTimer = setTimeout(function () { target = null; }, 1000);
      if (track.scrollTo) track.scrollTo({ left: pageLeft(index), behavior: 'smooth' });
      else track.scrollLeft = pageLeft(index);
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      lastScroll = Date.now();
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        if (target !== null) {
          if (Math.abs(track.scrollLeft - pageLeft(target)) < 2) target = null;
          return;
        }
        setActive(nearestPage());
      });
    }, { passive: true });

    if (window.ResizeObserver) {
      // Resizing the window: keep the current page lined up.
      new ResizeObserver(function () {
        var expected = pageLeft(current);
        if (Date.now() - lastScroll > 200 && Math.abs(track.scrollLeft - expected) > 2) {
          track.scrollLeft = expected;
        }
      }).observe(track);
    }

    // Theme editor: selecting a question opens the page it is on.
    group.__vmfFaqShow = function (el) {
      var page = el && el.closest && el.closest('.vmf-faq__page');
      var index = pages.indexOf(page);
      if (index !== -1) go(index);
    };

    setActive(0);
  }

  function bootFaq(root) {
    if (!document.body.classList.contains('template-product')) return;
    toArray(root.querySelectorAll('[data-section-type="double"] collapsible-elements')).forEach(function (group) {
      try { setupFaq(group); } catch (err) { warn(err); }
    });
  }

  document.addEventListener('shopify:block:select', function (event) {
    var group = event.target && event.target.closest && event.target.closest('collapsible-elements');
    if (group && group.__vmfFaqShow) group.__vmfFaqShow(event.target);
  });

  /* ----------------------------------------------------------------- wiring */

  function update(container, variant) {
    var filter = setupFilter(container);
    if (filter) applyFilter(filter, variant);
    var tiles = setupTiles(container);
    if (tiles) syncTiles(tiles, variant);
  }

  function whenDefined(name, root) {
    if (!root.querySelector(name) || !window.customElements) return Promise.resolve();
    return Promise.race([
      customElements.whenDefined(name),
      new Promise(function (resolve) { setTimeout(resolve, 3000); })
    ]);
  }

  function boot(root) {
    var galleries = root.querySelectorAll('product-images');
    toArray(galleries).forEach(function (images) {
      // Same element the theme fires theme:variant:change on.
      var container = images.closest('[data-section-type]');
      if (!container) {
        images.setAttribute('data-vmf-ready', '');
        return;
      }
      // Gallery height: all product pages, and no need to wait for the
      // theme's components below.
      if (container.querySelector('.product__page')) watchGallery(images);

      Promise.all([
        whenDefined('product-images', container),
        whenDefined('product-thumbs', container),
        whenDefined('popout-select', container)
      ]).then(function () {
        try {
          var product = getProduct(container);
          if (isScentProduct(product)) {
            update(container, currentVariant(container, product));
          }
          // Lines under the gallery on every product page (phones only; the
          // CSS hides them on desktop).
          if (isScentProduct(product) || container.querySelector('.product__page')) {
            refreshDots(images);
          }
        } catch (err) {
          warn(err);
        }
        images.setAttribute('data-vmf-ready', '');
      });
    });
  }

  document.addEventListener('theme:variant:change', function (event) {
    var el = event.target;
    var container = el && el.closest && el.closest('[data-section-type]');
    if (!container || !event.detail || !event.detail.variant) return;
    if (!isScentProduct(getProduct(container))) return;
    try {
      update(container, event.detail.variant);
    } catch (err) {
      warn(err);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
    bootFaq(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); bootFaq(document); });
  } else {
    boot(document);
    bootFaq(document);
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
